import api from '@/services/Api';

export default {
    async createModel ({ commit }, { model, item }) {
        await model.create(item);
    },

    async updateModel ({ commit }, item) {
        await item.update(item.getDirty());
    },

    async updateModelOrder ({ commit }, { item, order }) {
        await item.updateOrder(order);
    },

    async deleteModel ({ commit }, item) {
        await item.destroy(this.$t('actions.delete-confirmation'));
    },
    async login ({ commit, state }, { username, password, code }) {
        let data = {
            username,
            password,
        };

        if (code) {
            data = { code };
            Object.assign(data, { portal: true });
        }

        return api.post('/auth/login', data, { skipAuthRefresh: true }).then((response) => {
            if (response.data.user) {
                localStorage.setItem('APP_PORTAL_TOKEN', response.data.access_token);
                commit('SET_USER', response.data.user);
            }

            return response;
        });
    },

    /**
     * Get the currently logged in user by requesting it from the API and
     * set all select lists
     * @return {Promise}
     */
    async me ({ commit, state }) {
        const response = await api.get('auth/me');

        commit('SET_USER', response.data.user);

        for (const key in response.data.lists) {
            commit(`SET_${key.toUpperCase()}`, response.data.lists[key]);
        }

        return response.data;
    },

    /**
     * @return {Promise}
     */
    async refresh ({ commit, state }) {
        return api
            .post('/auth/refresh', {}, { skipAuthRefresh: true })
            .then((response) => {
                localStorage.setItem('APP_PORTAL_TOKEN', response.data.access_token);
                commit('SET_USER', response.data.user);
                return response;
            })
            .catch(() => {
                // Refresh failed, so we just logout
                localStorage.removeItem('APP_QUOTE_TOKEN');
                localStorage.removeItem('APP_PORTAL_TOKEN');
                commit('SET_USER', {});
                window.$router.next({ name: 'login' });
            });
    },

    /**
     * @return {Promise<Function>} You should call the function returned from the promise so the tokens are actually removed.
     * This usually takes place after routing to the login page.
     */
    async logout ({ commit, state }) {
        return api.post('/auth/logout', {}, { skipAuthRefresh: true }).then((response) => {
            localStorage.removeItem('APP_QUOTE_TOKEN');
            localStorage.removeItem('APP_PORTAL_TOKEN');
            commit('SET_USER', {});
            return response;
        });
    },

    // Make this async again when the API is ready
    updateUserConfig ({ commit, state }, configs) {
        // TODO - Not implemented for the portal-app, revert this for app
        // await api.post('auth/me', {
        //     relationships: {
        //         configs,
        //     },
        // });
        commit('UPDATE_USER_CONFIG', configs);
        return Promise.resolve();
    },
    async getSystemStatus ({ commit, state }) {
        const el = document.createElement('a');
        const baseUrl = import.meta.env.VITE_API_URL || '/api';
        el.href = baseUrl;

        commit('SET_BASE_URL', baseUrl);
        commit('SET_HOSTNAME', el.hostname);
        commit('SET_SUBDOMAIN', el.hostname.split('.')[0]);

        return api.get('system/status')
            .then((response) => {
                commit('SET_SYSTEM_STATUS', response.data);
                return response;
            });
    },
};
